

import Vue from 'vue'
import App from './App'
import router from './router'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'

import $ from 'jquery'
import store from '@/store/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import SlipDel from 'vue-slip-delete'
import VueScroller from 'vue-scroller'

import app from './components/diyAssembly'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import touch from './components/touch.js'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'muse-ui-loading/dist/muse-ui-loading.css' 
import Loading from 'muse-ui-loading'

import Message from 'muse-ui-message'
import 'muse-ui-message/dist/muse-ui-message.css'
import './components/touch.js'
import 'muse-ui-toast/dist/muse-ui-toast.all.css'
import './style/style.css'
import Selector from 'vux/src/components/selector/index.vue'
import Group from 'vux/src/components/group/index.vue'

import 'babel-polyfill'
import Es6Promise from 'es6-promise'

Vue.component('selector', Selector)
Vue.component('group', Group)
Vue.use(MintUI)
Vue.use(Message)

Vue.use(app)
Vue.use(VueScroller)
Vue.use(MuseUI)
Vue.use(preview)
Vue.use(Loading)

Vue.config.productionTip = false
Vue.use(touch)


Vue.filter('moneyFormat', function(val) {
if(val === null || val === undefined || val === ''){
return '';
}
val = val.toString().replace(/\$|\,/g,'');
if(isNaN(val)) {
val = "0";
}
let sign = (val == (val = Math.abs(val)));
val = Math.floor(val*100+0.50000000001);
let cents = val%100;
val = Math.floor(val/100).toString();
if(cents<10) {
cents = "0" + cents
}
for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
}

return (((sign)?'':'-') + val + '.' + cents);
});

router.beforeEach((to, from, next) => {






NProgress.start()
if (to.path === '/login') {
sessionStorage.removeItem('user')
sessionStorage.removeItem('username')

next()
}





let user = sessionStorage.getItem('username')
if (to.path.indexOf('wechat') > 0) {
next()
} else if ((user == null || user === '') && to.path !== '/login') {
next({ path: '/login' })
} else {

if ((router.app.$children.length === 0 || user === 'undefined') && to.path !== '/login') {

router.app.$options.store.dispatch('GetUserInfo').then(res => {
next({ ...to }) // 放行路由
}).catch(error => {
console.error(error)
next({
path: '/login'})
})
} else {
next()
}
}
})
router.afterEach(transition => {
NProgress.done()
})
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
});
require('es6-promise').polyfill()
Es6Promise.polyfill()



// WEBPACK FOOTER //
// ./src/main.js